import { Row, Col } from "antd";
import image from "../../images/internal-server-error.svg";
import { ContactUs } from "../../components/ContactUs";
import { useSelector } from "react-redux";
import "../NotFound/styles.scss";

type InternalServerErrorProps = {
  dashboard?: boolean;
};

export const InternalServerError = ({
  dashboard,
}: InternalServerErrorProps) => {
  const metaData = useSelector((state: any) => state.metaData);

  return (
    <div className={`${!dashboard ? "h-100" : ""}`}>
      <Row className="flex-column justify-center h-100 error-page">
        <Row>
          <Col className="error-page-left__container">
            <h1 className="header h h1 pb-9">Sorry, unexpected error.</h1>
            <div className="pt-9 pb-9">
              <div className="text">Error code: 500.</div>
              <div className="text pt-6">
                There is a technical problem that we're working on. We’ll fix
                everything shortly.
              </div>
            </div>
            <h4 className="pt-9 pb-8 h h4">What to do?</h4>
            <div className="text pb-5">You might try again later.</div>
            {metaData && metaData.companySupportEmail && (
              <div className="text pb-9">
                Or if you need immediate help,{" "}
                <ContactUs href={`mailto:${metaData.companySupportEmail}`} />.
              </div>
            )}
            <div className="text pt-9">Thanks for your patience!</div>
          </Col>
          <Col className="error-img">
            <img src={image} alt="internal-server-error" />
          </Col>
        </Row>
      </Row>
    </div>
  );
};
